import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import OwButton from "../../../shared/OwButton/OwButton";
import { OwFnInput } from "../../../shared/OwFnInput/OwFnInput";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import HelperService from "../../../../services/HelperService";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import SupplierContext from "../../../../contexts/SupplierContext";
import UserContext from "../../../../contexts/UserContext";
import { SocketContext } from "../../../../contexts/SocketContext";
import IUiSocketSetup from "../../../../models/IUiSocketSetup";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IUpdateSupplierDTO from "../../../../models/DTO/IUpdateSupplierDTO";

type Props = {
    closeFn: () => void;
};

export const StateByStateTaxSidebar = (props: Props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);
    const socket = useContext(SocketContext)!;

    const stateOptions = HelperService.getUsStates();
    const [state, setState] = useState("");
    const [taxRate, setTaxRate] = useState(0);

    const [taxDetails, setTaxDetails] = useState(supplierModel.sales_tax_config || {});

    const onUpdateSupplier = () => {
        props.closeFn();
    };

    const sockets: IUiSocketSetup[] = [{ endpoint: EndpointsEnum.SupplierOnUpdateSupplier, fn: onUpdateSupplier }];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        return () => {
            for (const _socket of sockets) {
                socket.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        switch (name) {
            case "stateAbbr":
                setState(value);
                break;

            case "tax_rate":
                setTaxRate(Number(value));
                break;
        }
    };

    const saveDetails = () => {
        const payload: IUpdateSupplierDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            supplierModel: {
                sales_tax_config: taxDetails,
            },
        };

        socket.emit(EndpointsEnum.SupplierUpdateSupplier, payload);
    };

    const addState = () => {
        const _taxDetails = { ...taxDetails };

        _taxDetails.usePerStateTax = true;
        _taxDetails.includedStates = {
            ..._taxDetails.includedStates,
            [state]: taxRate,
        };

        setTaxDetails(_taxDetails);
    };

    const removeState = (stateAbbr: string) => {
        const _taxDetails = { ...taxDetails };

        delete _taxDetails.includedStates[stateAbbr];

        setTaxDetails(_taxDetails);
    };

    return (
        <div className={"StateByStateTaxSidebar p-2"}>
            <div className={"d-flex justify-content-between align-items-center"}>
                <OwTitle title={"state_by_state_tax"} tag={"h4"} />
                <div>
                    <OwButton centerIconClass={"fas fa-times"} fn={props.closeFn} className={"btn-danger"} />
                </div>
            </div>

            <div className="mt-3">
                <div className={"d-flex align-items-end"}>
                    <div>
                        <OwLabel title={"state"} isBold={true} />
                        <OwSelectOption
                            options={stateOptions}
                            fn={handleChange}
                            titleProp={"title"}
                            valueProp={"value"}
                            name={"stateAbbr"}
                            selectedOption={state}
                            hasSelectedOptionProp={false}
                        />
                    </div>
                    <div className={"ms-2"}>
                        <OwLabel title={"tax_rate"} />
                        <OwFnInput fn={handleChange} name={"tax_rate"} value={taxRate} type={"number"} />
                    </div>
                    <div className={"ms-2"}>
                        <OwButton title={"add"} className={"btn-primary"} leftIconClass={"fas fa-plus"} fn={addState} />
                    </div>
                </div>
            </div>

            <div className="mt-3">
                {Object.keys(taxDetails.includedStates || {}).map((key) => {
                    const rate = taxDetails.includedStates[key];

                    return (
                        <div key={key} className={"d-flex"}>
                            <div className={"w-2r"}>
                                <i
                                    className={"fad fa-trash-alt text-danger pointer"}
                                    onClick={() => {
                                        removeState(key);
                                    }}
                                />
                            </div>
                            <div className={"w-5r"}>{key}</div>
                            <div className={"w-5r"}>{rate}</div>
                        </div>
                    );
                })}
            </div>

            <div className="mt-3">
                <OwButton title={"save"} fn={saveDetails} />
            </div>
        </div>
    );
};
